module.exports = __webpack_public_path__ + "static/screenshot_04@2x-ff4a551b3ac81684b704bb0a7f03976c.png";